import $ from './utils/_jquery.js';

$(document).ready(function () {
	$(document).on('click', '.c-toc a[href^="#"]', function (e) {
		e.preventDefault();

		const target = $(this).attr('href');
		const $target = $(target);

		if (!$target.length) return;
		$('html, body').animate(
			{ scrollTop: $target.offset().top - 70 },
			600
		);
	});
});
